import React from "react"
import { OgTags } from "../components/OpenGraph";
import Header from "../components/Header"
import Footer from "../components/Footer"
import Team from "../components/Team"
import TwoCol from "../components/TwoCol"
import Testimonials from "../components/Testimonials"
import Brands from "../components/Brands"
import ContentImage from "../components/ContentImage"

const logoFeat = [
  {
    name: 'Gatsby',
    image: require('../assets/svg/gatsby-1.svg'),
    link: 'https://www.gatsbyjs.org/showcase/fullstackhq.com',
    activeLink: true
  }, {
    name: 'Awards',
    image: require('../assets/svg/brands-awwwards-logo.svg'),
    link: 'https://www.awwwards.com/sites/psd-wizard-1',
    activeLink: true
  }, {
    name: 'Css Design Awards',
    image: require('../assets/svg/brands-cssdesign-logo.svg'),
    link: 'https://www.cssdesignawards.com/sites/psd-wizard/32529/',
    activeLink: true
  }, {
    name: 'JAMStack',
    image: require('../assets/svg/brands-jamstack-logo.svg'),
    link: 'https://jamstack.org/examples/',
    activeLink: true
  }, {
    name: 'React Static',
    image: require('../assets/svg/brands-react-logo.svg'),
    link: 'https://github.com/react-static/react-static#sites-built-with-react-static',
    activeLink: true
  }
]

const testimonyList = [
  {
    text: "Wow. U guys are simply amazing. This design is stunnning. Your design team rocks @Peng! They nailed it first go. Quite impressive",
    image: require('../assets/images/eddie-machaalani.png'),
    name: 'Eddie Machaalani',
    position: 'BigCommerce, Co-founder'
  },
  {
    text: `I was incredibly impressed by how you matched specs with clean code. And the team is super easy to work with!`,
    image: require('../assets/images/mohammed-abid.png'),
    name: 'Mohammed Abid',
    position: 'Facebook, Product Designer'
  }, {
    text: `The client (and me) are thrilled with the end result and are thankful for you and your team's great skills, communication, timeless, and quality of work!`,
    image: require('../assets/images/tim-haskins.png'),
    name: 'Tim Haskins',
    position: 'UpliftCX, CEO'
  }
]

const teamList = [
  {
    image: require('../assets/images/team/pengv2.png'),
    name: 'Christopher "Peng" Enriquez',
    position: 'CEO & Co-Founder',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">Peng Enriquez is an entrepreneur, product designer, and software engineer with 18 years of experience in the IT industry. He is the co-founder and CEO of Fullstack HQ and Raket.PH. Previously, he founded NarraSpark Inc, an IT services company based in Clark Freeport Zone, Philippines that was acquired in 2015.</p>
      <p className="member-desc p-md">Peng has deep experience leading and scaling tech companies. At NarraSpark, he grew the team from 7 to over 80 employees before its acquisition. As CEO of Fullstack HQ, he has self-funded the company to profitability over its 10 years of operation, working with clients like Accenture, Holcim, and BigCommerce founder.</p>
      <p className="member-desc p-md">In addition to entrepreneurship, Peng has spent years in software engineering roles. He was formerly a UX designer at Plotly, a leader in low-code data apps. Prior, he led development teams as a full stack engineer at companies including Zuellig Pharma, Takeda Pharmaceuticals, and Direct Technology.</p>
      <p className="member-desc p-md">In 2003, Peng was awarded "One of the Outstanding Computer Engineering Students" in Angeles University Foundation. He holds a Microsoft Certified Professional designation.</p>
    </div>
  },
  {
    image: require('../assets/images/team/carlet2024.png'),
    name: 'Carlet Berlly Enriquez',
    position: 'CFO & Co-Founder',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">Carlet is the CFO and co-founder of Fullstack HQ and Raket.PH, overseeing the finance and accounting functions. She manages the finances, prepares financial reports, and oversees cash flow and capital needs. Together with Peng, they bootstrapped Fullstack HQ from negative all the way to a steady positive cash flow. Carlet has established the company's culture that helped in growing a highly-competitive and driven team of 40+ in 2 years.</p>
      <p className="member-desc p-md">She graduated from Holy Angel University with a degree in BSBA major in Finance and Management Accounting. Prior to Fullstack HQ, Carlet spent 4 years in accounts receivable, UK payroll and financial management for her first startup IT company and for various local businesses. </p>
   </div>
  },
    {
    image: require('../assets/images/team/crizelle-anne.png'),
    name: 'Crizelle Anne Razon',
    position: 'Office Admin',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Office Admin at Fullstack HQ
      </p>
    </div>
  },
    {
    image: require('../assets/images/team/francisco.png'),
    name: 'Francis Enriquez Jr.',
    position: 'IT Administrator',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Francis handle current position as a IT Admin at Fullstack HQ, He focusing on maintenance of computer hardware, internet server problem and other computer components problem.
      </p>
    </div>
  },
  {
    image: require('../assets/images/team/blank.png'),
    name: 'Mauren Hermosa',
    position: 'Project Coordinator',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Project Coordinator at Fullstack HQ
      </p>
    </div>
  },
  {
    image: require('../assets/images/team/blank.png'),
    name: 'Allen Jaired Ayson',
    position: 'Project Coordinator',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Project Coordinator at Fullstack HQ
      </p>
    </div>
  },
  {
    image: require('../assets/images/team/kaye-ann.png'),
    name: 'Kaye Ann Layug',
    position: 'Developer',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Kaye serves as a Web Developer Trainer at Fullstack HQ. With a degree in Bachelor of Science in Information Technology, she assures quality in every project, which revolves around converting UI/UX design wireframes to actual code.
      </p>
    </div>
  },
  {
    image: require('../assets/images/team/naey.png'),
    name: 'Christian Naey Gonzales',
    position: 'Developer',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Naey is a Web Developer at Fullstack HQ. She converts PSD to HTML, provides pixel perfect websites, communicates with other team members and handles multiple projects. She graduated with a Bachelor of Science in Computer Science at City College of Angeles where she was on the dean's list. She had previously worked at My Intellects Inc. as a graphic designer.
      </p>
    </div>
 },
  {
    image: require('../assets/images/team/rosalinda.png'),
    name: 'Rosalinda Soriano',
    position: 'Developer',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Rosalinda is a Web Developer at Fullstack HQ where she converts UI/UX design wireframes to actual code. She graduated with a Bachelor of Science in Computer Science at City College of Angeles. She also gained certifications in Arduino: Introduction & Programming, Arduino: A Hands-On Introductory Workshop, CCNA R&S: Introduction to Networks, CCNA R&S: Connecting Networks, and CCNA R&S: Scaling Networks. Prior to joining the company, she had worked at McDonalds and Jollibee as a service crew.
      </p>
    </div>
  },
  {
    image: require('../assets/images/team/richard1.png'),
    name: 'Richard Dela Cruz Jr',
    position: 'Developer',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Richard serves as a Web Developer at Fullstack HQ. With a degree in Bachelor of Science in Computer Science, he earned various university recognitions such as being a dean's list in 2019 and 2020 and membership at PSITE Region 3. His job focuses on front-end development with expertise in Shopify, Wordpress and Javascript. 
      </p>
    </div>
  },
  {
    image: require('../assets/images/team/nica.png'),
    name: 'Nica Alimurung',
    position: 'Developer',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Nica is a Front-end Developer at Fullstack HQ.
        She is a Tarlac State University alumna holds a bachelor's degree in Information Technology, specializing in Web and Mobile Applications. Nica's commitment to academic success was evident as she graduated as Cum Laude.
        Nica is a web developer who specialized on converting figma designs into actual code.
      </p>
    </div>
  },
  {
    image: require('../assets/images/team/allen.png'),
    name: 'Allen Alipio',
    position: 'Developer',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Allen is a Front-end Developer at Fullstack HQ. A graduate of Tarlac State University, with a bachelor's degree in Information Technology. Throughout his academic journey, Allen's dedication to excellence shone brightly as he secured a spot on the dean's list from 2021 to 2023 and also graduated as a Cum Laude.
      </p>
      <p className="member-desc p-md">
        He is a web developer proficient on using Tailwind CSS, Angular, React, and Wordpress, while PHP on the backend.
      </p>
    </div>
  },
  {
    image: require('../assets/images/team/klyde.png'),
    name: 'Klyde Vincent Sangalang',
    position: 'Developer',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Web Developer at Fullstack HQ
      </p>
    </div>
  },
  {
    image: require('../assets/images/team/patrick.png'),
    name: 'Patrick Perez',
    position: 'Developer',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Web Developer at Fullstack HQ
      </p>
    </div>
  },
  {
    image: require('../assets/images/team/jerald-francis.png'),
    name: 'Jerald Francis Bagsic',
    position: 'Developer',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Web Developer at Fullstack HQ
      </p>
    </div>
  },
  {
    image: require('../assets/images/team/jazper.png'),
    name: 'Jazper Garcia',
    position: 'Developer',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Web Developer at Fullstack HQ
      </p>
    </div>
  },
  {
    image: require('../assets/images/team/eduardo.png'),
    name: 'Eduardo Mirasol Jr.',
    position: 'Developer',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Web Developer at Fullstack HQ
      </p>
    </div>
  },
  {
    image: require('../assets/images/team/christian-2.png'),
    name: 'Christian David Cruz',
    position: 'Developer',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Web Developer at Fullstack HQ
      </p>
    </div>
  },
  {
    image: require('../assets/images/team/april-joyce.png'),
    name: 'April Joyce Gomez',
    position: 'Developer',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Web Developer at Fullstack HQ
      </p>
    </div>
  },
   {
    image: require('../assets/images/team/anthony.png'),
    name: 'Anthony Cabulang',
    position: 'Developer',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Web Developer at Fullstack HQ
      </p>
    </div>
  },
  {
    image: require('../assets/images/team/alieu.png'),
    name: 'Alieu Farreeze Arcilla',
    position: 'Developer',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Web Developer at Fullstack HQ
      </p>
    </div>
  },
  {
    image: require('../assets/images/team/blank.png'),
    name: 'Alexandra Alvez',
    position: 'Designer',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        UI/UX Designer at Fullstack HQ
      </p>
    </div>
  },
   {
    image: require('../assets/images/team/blank.png'),
    name: 'Kimberly Mae De Leon',
    position: 'Designer',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Web Designer at Fullstack HQ
      </p>
    </div>
  },
   {
    image: require('../assets/images/team/blank.png'),
    name: 'Nowie Torres',
    position: 'Developer',
    description:
    <div className="member-desc-holder">
      <p className="member-desc p-md">
        Web Developer at Fullstack HQ
      </p>
    </div>
  }
]

const aboutContent = [
  {
    image: require('../assets/images/building.jpg'),
    name: 'Fullstack HQ Office',
    title: 'About Fullstack HQ',
    desc: 'Fullstack HQ is a web development outsource company where 100% of the work is done in-house. We partner with world-class entrepreneurs, design studios, tech companies, marketing agencies and startups helping them to increase efficiency & reduce development costs.'
  },
  {
    image: require('../assets/images/awards.jpg'),
    otherImage: require('../assets/images/honorable.jpg'),
    name: 'Fullstack HQ Awards',
    title: 'Award-Winning Company',
    desc: 'Our company has been awarded an "Honorable mention" from Awwwards and three awards from CSSDesignAwards. Those awards being Best UI Design, UX Design and Innovation. We’re also featured on Gatsby, React Static and JAMstack official websites.'
  },
   {
    image: require('../assets/images/fshq-team-2025.png'),
    name: 'Fullstack HQ Team',
    title: 'Agile Team Organization',
    desc: 'We aren’t one of those ‘expert’ outsourcing companies that try to do everything. We specialize in one thing – and do it really well, full stack development. Fullstack HQ brings agile development teams with difficult-to-find expertise to execute faster and more cost effectively than traditional methods.'
  },
  {
    image: require('../assets/images/kulitan.jpg'),
    name: 'Fullstack HQ Events',
    title: "We're connected to the digital community",
    desc: 'We can frequently be found speaking at the industry events as well as hosting various educational tours and workshops in our office.'
  },
]

const cta = {
  hasBackground: false,
  hasButton: true,
  imagePrimary: false,
  isFullContent: true,
  noImage: false,
  image: require('../assets/images/about-banner.png'),
  title: "The smarter way to outsource web development projects",
  buttons: [
    {
      type: 'normal',
      text: 'Book a call',
      link: 'https://calendly.com/fullstackhq/meeting',
      beacon: false,
      external: true
    }, {
      type: 'outline',
      text: 'Chat with us',
      link: '/',
      beacon: true
    }
  ]
}

const ctaJoin = {
  hasBackground: true,
  hasButton: true,
  imagePrimary: false,
  isFullContent: true,
  noImage: true,
  noImageCTA: true,
  title: 'Grow with us',
  desc: "Play a major role in one of the fastest growing tech companies in the Philippines.",
  buttons: [
    {
      type: 'normal',
      text: 'View current vacancies',
      link: '/careers',
      beacon: false
    }
  ]
}

function About() {
  return (
    <div className="member-desc-holder">
      <OgTags
        ogTitle="Full Stack Web Design and Development Team Philippines | Fullstack HQ"
        ogDescription="Fullstack HQ is on a mission to empower the future of work by connecting digitals experts in Philippines to businesses around the world."
        ogUrl="https://fullstackhq.com/about"
      />
      <Header />
      <main className="about initialized-header">
        <ContentImage content={ cta }  />
        <TwoCol
          about = {aboutContent}
        />
        <Team
          team = { teamList }
        />
        <Testimonials
          title="Loved by world-class entrepreneurs & tech companies"
          testimony={ testimonyList }
        />
        <Brands
          text="We've been featured on"
          brands={ logoFeat }
        />
         <ContentImage content={ ctaJoin }  />
      </main>
      <Footer />
   </div>
  )
}

export default About
